import styled from "styled-components";
import {IJackpotWidgetLogoBoxProps} from "./jackpot-widget-logo.box";

export const JackpotWidgetLogoMrGreenBox = styled.img<IJackpotWidgetLogoBoxProps>`
   display: none;
`;